import { Component, OnInit,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {GeneralService} from "../services/general.service"
@Component({
  selector: 'app-liste-action-dialig',
  templateUrl: './liste-action-dialig.component.html',
  styleUrls: ['./liste-action-dialig.component.scss']
})
export class ListeActionDialigComponent implements OnInit {

  constructor(public generalService : GeneralService,public dialogRef: MatDialogRef<ListeActionDialigComponent>, @Inject(MAT_DIALOG_DATA) public data) { }
  avtAction_Code= "";
  avtActions;
  ngOnInit() 
  {
    this.setAction()
  }
  save() 
  {
    if(this.avtAction_Code != "")
    {
      this.dialogRef.close(this.avtAction_Code);
      document.getElementById("btnFermer").click();
    }      
    else
      alert("Veuillez choisir un elément")
  }

  close() 
  {
    document.getElementById("btnFermer").click();
    this.dialogRef.close("");
  }
  setAction()
  {
    if(this.generalService.isNotEmpty(this.generalService.collaborateurConnecter))  
      this.generalService.rechercheTable(this.generalService.urlListeActionCol+this.generalService.collaborateurConnecter).subscribe( action => 
      {
        this.avtActions = this.generalService.sort(action,"avtAction_Intitule");  
      });
    else
      setTimeout(()=>
      {
        this.setAction();
      },100)
  }
}
